import { useState } from 'react'
import defaultProfile from "../../UserProfile/EmptyProfile.jpg";

export function StoryModeMultipleChoice({ cQ, onAnswerClick, currentScore, quizLength, user, lastFeedback, setLastFeedback }) {
  return (
    <div className="quick-quiz-story-mode">
      <div className="quiz-top-panel">
        <div className="teacher-image-container">
          <img src="/images/Teacher.png" alt="Teacher" className="quiz-character-img" />
        </div>
        <div className="quiz-question-box">
          <p className="quiz-question-text">{cQ.question}</p>
        </div>
      </div>
      <div className="quiz-bottom-panel">
        <div className="quiz-answer-box-left">
          {cQ.options.map((opt, idx) => (
            <button
              key={idx}
              className="quiz-answer-btn"
              onClick={() => onAnswerClick(opt)}
              disabled={lastFeedback && !lastFeedback.isCorrect}
            >
              {opt}
            </button>
          ))}
        </div>
        <div className="student-image-container">
          <img src={user?.avatar ?? defaultProfile} alt="Student" className="quiz-character-img-student" />
        </div>
      </div>
      {lastFeedback && (
        <div style={{
          marginTop: 8, padding: 8, borderRadius: 8,
          background: lastFeedback.isCorrect ? "#e0ffe0" : "#fff0f0"
        }}>
          {lastFeedback.isCorrect
            ? <b style={{ color: "#228833" }}>Correct!</b>
            : <>
                <b style={{ color: "#c33" }}>Not quite.</b>
                <div>
                  The correct answer was: <b>{lastFeedback.correctAnswer}</b>
                </div>
                <button className="button1" style={{ marginTop: 8 }} onClick={() => setLastFeedback(null)}>Try Again</button>
              </>
          }
        </div>
      )}
      <p className="quiz-score-display">
        Score: {currentScore}/{quizLength}
      </p>
    </div>
  );
}

export function StoryModeFillInBlank({ cQ, onSubmit, currentScore, quizLength, user, lastFeedback, setLastFeedback }) {
  const [userInput, setUserInput] = useState("");
  function handleSubmit() {
    onSubmit(userInput);
  }
  return (
    <div className="quick-quiz-story-mode">
      <div className="quiz-top-panel">
        <div className="teacher-image-container">
          <img src="/images/teacher.png" alt="Teacher" className="quiz-character-img" />
        </div>
        <div className="quiz-question-box">
          <p className="quiz-question-text">{cQ.question}</p>
        </div>
      </div>
      <div className="quiz-bottom-panel">
        <div className="quiz-answer-box-left">
          <input
            type="text"
            value={userInput}
            onChange={e => setUserInput(e.target.value)}
            placeholder="Type your answer"
            className="quiz-input"
            disabled={lastFeedback && !lastFeedback.isCorrect}
          />
          <button className="quiz-answer-btn" onClick={handleSubmit} disabled={lastFeedback && !lastFeedback.isCorrect}>
            Submit
          </button>
        </div>
        <div className="student-image-container">
          <img src={user?.avatar ?? defaultProfile} alt="Student" className="quiz-character-img-student" />
        </div>
      </div>
      {lastFeedback && (
        <div style={{ marginTop: 8, padding: 8, borderRadius: 8, background: lastFeedback.isCorrect ? "#e0ffe0" : "#fff0f0" }}>
          {lastFeedback.isCorrect ? (
            <b style={{ color: "#228833" }}>Correct!</b>
          ) : (
            <div>
              <b style={{ color: "#c33" }}>Not quite right:</b>
              <ul style={{ margin: 0, paddingLeft: 20 }}>
                {lastFeedback.errors.map((err, idx) => <li key={idx}>{err}</li>)}
              </ul>
              <div style={{ marginTop: 5, fontStyle: "italic", color: "#444" }}>
                <b>Sample answer:</b> <span style={{ color: "#227" }}>{lastFeedback.sample}</span>
              </div>
              <button
                className="button1"
                style={{ marginTop: 8 }}
                onClick={() => {
                  setUserInput("");
                  if (typeof window !== "undefined" && window.document) {
                    document.querySelector("input.quiz-input")?.focus();
                  }
                  if (typeof setLastFeedback === "function") setLastFeedback(null);
                }}
              >Try Again</button>
            </div>
          )}
        </div>
      )}
      <p className="quiz-score-display">
        Score: {currentScore}/{quizLength}
      </p>
    </div>
  );
}

export function StoryModeIdentify({ cQ, onSubmit, currentScore, quizLength, user, lastFeedback, setLastFeedback }) {
  const [userInput, setUserInput] = useState("");
  function handleSubmit() { onSubmit(userInput); }
  return (
    <div className="quick-quiz-story-mode">
      <div className="quiz-top-panel">
        <div className="teacher-image-container">
          <img src="/images/teacher.png" alt="Teacher" className="quiz-character-img" />
        </div>
        <div className="quiz-question-box">
          <p className="quiz-question-text">{cQ.question}</p>
        </div>
      </div>
      <div className="quiz-bottom-panel">
        <div className="quiz-answer-box-left">
          <p>Type answers separated by commas</p>
          <input
            type="text"
            value={userInput}
            onChange={e => setUserInput(e.target.value)}
            placeholder="e.g. children, playground, songs"
            className="quiz-input"
            disabled={lastFeedback && !lastFeedback.isCorrect}
          />
          <button className="quiz-answer-btn" onClick={handleSubmit} disabled={lastFeedback && !lastFeedback.isCorrect}>
            Submit
          </button>
        </div>
        <div className="student-image-container">
          <img src={user?.avatar ?? defaultProfile} alt="Student" className="quiz-character-img-student" />
        </div>
      </div>
      {lastFeedback && (
        <div style={{
          marginTop: 8, padding: 8, borderRadius: 8,
          background: lastFeedback.isCorrect ? "#e0ffe0" : "#fff0f0"
        }}>
          {lastFeedback.isCorrect
            ? <b style={{ color: "#228833" }}>Correct!</b>
            : <>
                <b style={{ color: "#c33" }}>Not quite.</b>
                <div>{lastFeedback.message}</div>
                <div>
                  <b>Correct answer(s):</b> {cQ.correctAnswers.join(", ")}
                </div>
                <button className="button1" style={{ marginTop: 8 }} onClick={() => setLastFeedback(null)}>Try Again</button>
              </>
          }
        </div>
      )}
      <p className="quiz-score-display">
        Score: {currentScore}/{quizLength}
      </p>
    </div>
  );
}